import { render, staticRenderFns } from "./ClienteTipoPedido.vue?vue&type=template&id=3789b752&scoped=true"
import script from "./ClienteTipoPedido.vue?vue&type=script&lang=js"
export * from "./ClienteTipoPedido.vue?vue&type=script&lang=js"
import style0 from "./ClienteTipoPedido.vue?vue&type=style&index=0&id=3789b752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3789b752",
  null
  
)

export default component.exports